import { DividerContainer } from './styles';

const Divider = () => {
  return <DividerContainer />;
};

export default Divider;
